const EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

const forceReflow = (el) => el.offsetHeight;

const runTransition = (el, duration, applyInitial, applyTarget, onDone) => {
    applyInitial();
    forceReflow(el);

    el.style.transition = `transform ${duration}ms ${EASING}, opacity ${duration}ms ${EASING}`;
    applyTarget();

    const timeoutId = setTimeout(() => {
        el.style.transition = '';
        onDone?.();
    }, duration);

    return () => clearTimeout(timeoutId);
};

export const fadeIn = (el, duration = 1000, display = 'block') => {
    runTransition(
        el,
        duration,
        () => {
            el.style.transition = 'none';
            el.style.opacity = '0';
            el.style.display = display;
        },
        () => {
            el.style.opacity = '1';
        },
    );
};

export const fadeOut = (el, duration = 1000, callback = () => {}) => {
    runTransition(
        el,
        duration,
        () => {
            el.style.transition = 'none';
            el.style.opacity = '1';
        },
        () => {
            el.style.opacity = '0';
        },
        () => {
            el.style.display = 'none';
            callback();
        },
    );
};

export const slideInFromRight = (el, duration = 1000, callback = () => {}) => {
    runTransition(
        el,
        duration,
        () => {
            el.style.transition = 'none';
            el.style.transform = 'translate3d(100%, 0, 0)';
            el.style.display = 'block';
        },
        () => {
            el.style.transform = 'translate3d(0, 0, 0)';
        },
        callback,
    );
};

export const slideOutToRight = (el, duration = 1000, parentEl = null, callback = () => {}) => {
    runTransition(
        el,
        duration,
        () => {
            el.style.transition = 'none';
            el.style.transform = 'translate3d(0, 0, 0)';
        },
        () => {
            el.style.transform = 'translate3d(100%, 0, 0)';
        },
        () => {
            el.style.display = 'none';

            if (parentEl) {
                parentEl.style.display = 'none';
            }

            callback();
        },
    );
};

export default {
    fadeIn,
    fadeOut,
    slideInFromRight,
    slideOutToRight,
};
